import React from 'react';
import styled from 'styled-components';
import { grayShades } from '../../../../../../styles/abstracts/colors';
import ListBenchmark from '../_Containers/ListBenchmark/ListBenchmark';

const Container = styled.div`
  display: flex;
  align-items: center;
  color: ${grayShades.g800};
  font-weight: bold;
  margin: 0.75em 0 0.75em 2em;
  flex-wrap: wrap;
`;

const Title = styled.p`
  margin-right: 0.5em;
`;

class ListBenchmarkContainer extends React.Component {
  render() {
    return (
      <Container>
        <Title>Benchmark</Title>
        <ListBenchmark />
      </Container>
    );
  }
}

export default ListBenchmarkContainer;
